// App.js  – route‑level code‑splitting version
import axios from "axios";
import "leaflet/dist/leaflet.css";
import RequireAuth from "./auth/RequireAuth";
import CardDetailNavigator from "./pages/CardDetailNavigator.jsx";
// 4) React‑Router & React‑lazy
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";

// 1) Axios defaults
axios.defaults.baseURL        = "/vps";
axios.defaults.withCredentials = true;

// 2) Monkey‑patch window.fetch → /vps/…
const _fetch = window.fetch;
window.fetch = (resource, init) => {
  let url = resource;
  if (typeof resource === "string" && resource.startsWith("/") && !resource.startsWith("/vps/")) {
    url = "/vps" + resource;
  }
  return _fetch(url, init);
};

// 3) Global CSS


/* ─────────────── ROUTE COMPONENTS ─────────────── */

const AdminRegister             = lazy(() => import("./pages/AdminRegister"));
const AdminLogin                = lazy(() => import("./pages/AdminLogin"));
const AuditorLogin              = lazy(() => import("./pages/AuditorLogin"));
const AdminDashboard            = lazy(() => import("./components/Dashboard/AdminDashboard"));
const UserLogin                 = lazy(() => import("./pages/UserLogin"));
const AddUser                   = lazy(() => import("./components/AddUser"));
const UserList                  = lazy(() => import("./components/User/UserList"));
const RoleList                  = lazy(() => import("./components/User/RoleList"));
const CreateRolelist            = lazy(() => import("./components/User/CreateRolist"));
const CreateUres                = lazy(() => import("./components/User/CreateUser"));
const RiderList                 = lazy(() => import("./components/User/RiderList"));
const CreateRider               = lazy(() => import("./components/User/CreateRider"));
const CreateRiderCommission     = lazy(() => import("./components/User/CreateRiderCommission"));
const RiderCommissionList       = lazy(() => import("./components/User/RiderCommissionList"));
const AddStore                  = lazy(() => import("./components/store/AddStore"));
const StoreView                 = lazy(() => import("./components/store/StoreView"));
const AddSubscription           = lazy(() => import("./components/store/AddSubscription"));
const SubscriptionList          = lazy(() => import("./components/store/SubscriptionList"));
const SystemTab                 = lazy(() => import("./components/store/SystemTab"));
const Reports                   = lazy(() => import("./pages/Reports"));
const ProfitLossReport          = lazy(() => import("./components/Reports/ProfitLossReport"));
const SalesPaymentReport        = lazy(() => import("./components/Reports/SalesPaymentReport"));
const ItemTransfer              = lazy(() => import("./components/Reports/ItemTransfer"));
const StockTransferReport       = lazy(() => import("./components/Reports/StockTransfer"));
const SaleItemsReport           = lazy(() => import("./components/Reports/SaleItems"));
// const StockReport               = lazy(() => import("./components/Reports/StockReport"));
// const ItemCompare               = lazy(() => import("./components/Reports/ItemCompare"));
const CustomerOrders            = lazy(() => import("./pages/CustomerOrders"));
const Supplierlist              = lazy(() => import("./components/contact/Supplierlist"));
const Customerlist              = lazy(() => import("./components/contact/Customerlist"));
const AddSupplier               = lazy(() => import("./components/contact/AddSupplier"));
const Addcustomer               = lazy(() => import("./components/contact/AddCustomer/Addcustomer"));
const NewCustomer               = lazy(() => import("./components/contact/NewCustomer"));
const NewCustomerlist           = lazy(() => import("./components/contact/NewCustomerList"));
const ImportCustomer            = lazy(() => import("./components/contact/import/ImportCustomer"));
const ImportSupplier            = lazy(() => import("./components/contact/import/ImportSupplier"));
const AddItem                   = lazy(() => import("./components/Items/AddItems"));
const NewItem                   = lazy(() => import("./components/Items/NewItem"));
const AddService                = lazy(() => import("./components/Items/AddServices"));
const AddUpdateServices         = lazy(() => import("./components/Items/AddUpdateServices"));
const ItemList                  = lazy(() => import("./components/Items/Itemlist"));
const CategoriesList            = lazy(() => import("./components/Items/CategoriesList"));
const CategoriesListform        = lazy(() => import("./components/Items/CategoriesListform"));
const SubCategoryList           = lazy(() => import("./components/Items/SubCategoryList"));
const SubCategoryForm           = lazy(() => import("./components/Items/SubCategoryForm"));
const SubSubCategoryList        = lazy(() => import("./components/Items/SubSubCategoryList"));
const BrandsList                = lazy(() => import("./components/Items/BrandsList"));
const BrandForm                 = lazy(() => import("./components/Items/BrandForm"));
const VariantAdd                = lazy(() => import("./components/Items/VariantAdd"));
const VariantsList              = lazy(() => import("./components/Items/VariantsList"));
const PrintLabels               = lazy(() => import("./components/Items/PrintLabels"));
const ImportItems               = lazy(() => import("./components/Items/ImportItems"));
const ImportServices            = lazy(() => import("./components/Items/ImportServices"));
const ImportEntity              = lazy(() => import("./components/Items/ImportEntity"));
const AddAdvance                = lazy(() => import("./components/advance/addadvance"));
const AdvanceList               = lazy(() => import("./components/advance/advancelist"));
const CustomerCoupenList        = lazy(() => import("./components/coupens/CustomerCouponsList"));
const CreateCustomerCoupons     = lazy(() => import("./components/coupens/CreateCustomerCoupon"));
const CreateCoupon              = lazy(() => import("./components/coupens/CreateCoupon"));
const CouponsMaster             = lazy(() => import("./components/coupens/CouponsMaster"));
const CreateMasterCoupon        = lazy(() => import("./components/coupens/CreateMasterCoupon"));
const CouponForm                = lazy(() => import("./components/coupens/CreateCustomerCoupon"));
const DiscountCouponForm        = lazy(() => import("./components/coupens/CreateCoupon"));
const DiscountCouponList        = lazy(() => import("./components/coupens/CouponsMaster"));
const NewQuotation              = lazy(() => import("./components/Quotation/NewQuotation"));
const QuotationList             = lazy(() => import("./components/Quotation/QuotationList"));
const QuotationForm             = lazy(() => import("./components/Quotation/NewQuotation"));
const NewPurchase               = lazy(() => import("./components/purchase/newpurcheas"));
const PurchaseList              = lazy(() => import("./components/purchase/purchaselist"));
const PurchaseReturnsList       = lazy(() => import("./components/purchase/PurchaseReturnsList"));
const PurchaseReturn            = lazy(() => import("./components/purchase/purchasereturn"));
const POS                       = lazy(() => import("./components/Sales/POS"));
const AddSale                   = lazy(() => import("./components/Sales/AddSale"));
const AddSalesRetutrn           = lazy(() => import("./components/Sales/AddSalesReturn"));
const AddSalesReturn            = lazy(() => import("./components/Sales/AddSalesReturn"));
const SaleList                  = lazy(() => import("./components/Sales/SalesList"));
const SalesPayment              = lazy(() => import("./components/Sales/SalesPayment"));
const SalesPaymentList          = lazy(() => import("./components/Sales/SalesReturnsList"));
const ViewSale                  = lazy(() => import("./components/Sales/ViewSale"));
const ViewSaleReport                  = lazy(() => import("./components/Sales/ViewSaleReport"));
const ReceivePayment            = lazy(() => import("./components/Sales/ReceivePayment"));
const POSInvoice                = lazy(() => import("./components/Sales/POSInvoice"));
const SalesReturn               = lazy(() => import("./components/Sales/SalesReturn"));
const ViewPayment               = lazy(() => import("./components/Sales/ViewPayment"));
const AddAccount                = lazy(() => import("./components/Accounts/AddAccounts"));
const AccountList               = lazy(() => import("./components/Accounts/AccountList"));
const MoneyTransferList         = lazy(() => import("./components/Accounts/MoneyTransferList"));
const AddMoneyTransfer          = lazy(() => import("./components/Accounts/AddMoneyTransfer"));
const AddDeposit                = lazy(() => import("./components/Accounts/AddDeposit"));
const DepositList               = lazy(() => import("./components/Accounts/DepositList"));
const CashTransactions          = lazy(() => import("./components/Accounts/CashTransactions"));
const AddVanCash                = lazy(() => import("./components/Accounts/AddVanCash"));
const RiderAccountList          = lazy(() => import("./components/Accounts/RiderAccountList"));
const AccountLedger             = lazy(() => import("./components/Accounts/AccountLedger"));
const AddStockAdjustment        = lazy(() => import("./components/Stock/AddStockAdjustment"));
const AdjustmentList            = lazy(() => import("./components/Stock/AdjustmentList"));
const AddStockTransfer          = lazy(() => import("./components/Stock/AddStockTransfer"));
const TransferList              = lazy(() => import("./components/Stock/TransferList"));
const ExpenseList               = lazy(() => import("./components/Expenses/ExpensesList"));
const AddExpense                = lazy(() => import("./components/Expenses/AddExpense"));
const AddExpenseCategory        = lazy(() => import("./components/Expenses/AddExpenseCategory"));
const ExpenseCategoryList       = lazy(() => import("./components/Expenses/ExpenseCategoryList"));
const SendMessage               = lazy(() => import("./components/Message/SendMessage"));
const MessageTemplatesList      = lazy(() => import("./components/Message/MessageTemplatesList"));
const UnitsList                 = lazy(() => import("./components/Settings/UnitsList"));
const PaymentTypesList          = lazy(() => import("./components/Settings/PaymentTypes"));
const ChangePassword            = lazy(() => import("./components/Settings/ChangePassword"));
const Store                     = lazy(() => import("./components/Settings/Store"));
const TaxList                   = lazy(() => import("./components/Settings/TaxList"));
const SmsApi                    = lazy(() => import("./components/Settings/SmsApi"));
const PosSettingsForm           = lazy(() => import("./components/Settings/Sale"));
const AddTax                    = lazy(() => import("./components/Settings/AddTax"));
const AddTaxGroup               = lazy(() => import("./components/Settings/AddTaxGroup"));
const AddUnit                   = lazy(() => import("./components/Settings/AddUnit"));
const AddPaymentType            = lazy(() => import("./components/Settings/AddPaymentType"));
const AddCountry                = lazy(() => import("./components/Places/AddCountry"));
const AddState                  = lazy(() => import("./components/Places/AddState"));
const CountryList               = lazy(() => import("./components/Places/CountryList"));
const StateList                 = lazy(() => import("./components/Places/StateList"));
const WarehouseForm             = lazy(() => import("./components/Warehpuse/WarehouseForm"));
const WarehouseList             = lazy(() => import("./components/Warehpuse/WarehouseList"));
const WarehouseTracker          = lazy(() => import("./components/Warehpuse/WarehouseTracker"));
const TerminalList              = lazy(() => import("./components/Terminal/TerminalList"));
const CreateTerminal            = lazy(() => import("./components/Terminal/CreateTerminal"));
const AddBanner                 = lazy(() => import("./components/Banners/AddBanner"));
const BannersList               = lazy(() => import("./components/Banners/BannersList"));
const AddMarketingItems         = lazy(() => import("./components/Banners/AddMarketingItems"));
const MarketingItemsList        = lazy(() => import("./components/Banners/MarketingItemView"));
const AddProduct                = lazy(() => import("./components/Banners/AddProduct"));
const ProductListView           = lazy(() => import("./components/Banners/ProductListView"));
const DeletionRequests          = lazy(() => import("./components/admin/deletion-requests"));
const ProfileEdit               = lazy(() => import("./pages/ProfileEdit"));
const OrderList                 = lazy(() => import("./components/Order/OrderList/OrderList"));
const DeliverySlotCreate        = lazy(() => import("./components/DeliverySlot/DeliverySlotCreate"));
const DeliverySlotList          = lazy(() => import("./components/DeliverySlot/DeliverySlotList"));
const Audit                     = lazy(() => import("./components/Auditor/Audit"));
const AuditDashboard            = lazy(() => import("./components/Auditor/AuditDashboard"));
const OpenAuditList             = lazy(() => import("./components/Auditor/OpenAuditList"));
const AllAudits                 = lazy(() => import("./components/Auditor/AllAudits"));
const BucketCreate              = lazy(() => import("./components/Auditor/BucketCreate"));
const UserBucketList            = lazy(() => import("./components/Auditor/UserBucketList"));
const ImageMerger               = lazy(() => import("./pages/ImageMerger"));
const ItemImageManagement       = lazy(() => import("./components/ImageManagement/ItemImageManagement"));
const CategoryImageManagement   = lazy(() => import("./components/ImageManagement/CategoryImageManagement"));
const SubCategoryImageManagement= lazy(() => import("./components/ImageManagement/subcategory/SubCategoryImageManagement"));
const SubSubCategoryImageManagement = lazy(() => import("./components/ImageManagement/subsubcategory/SubSubCategoryImageManagement"));
const AddressManager            = lazy(() => import("./components/contact/AddressManager"));
const AddressList               = lazy(() => import("./components/contact/AddressList"));
const ChatPanel                 = lazy(() => import("./components/Message/ChatPanel"));
const RawLotList                = lazy(() => import("./components/purchase/RawLotList"));
const BulkStockTransfer         = lazy(() => import("./components/Stock/BulkStockTransfer"));
const BulkPurchaseUpload        = lazy(() => import("./components/purchase/BulkPurchaseUpload"));
const TransferDetails           = lazy(() => import("./components/Stock/TransferDetails"));
const PurchaseDetail            = lazy(() => import("./components/purchase/PurchaseDetail"));
const AdminBookingPanel         = lazy(() => import("./components/Booking/VanBookingPanel"));
const RiderClaimPanel           = lazy(() => import("./components/Booking/RiderClaimPanel"));
const MyJobsPanel               = lazy(() => import("./components/Booking/MyJobsPanel"));
const BluetoothPrinterConnector = lazy(() => import("./components/Settings/BluetoothPrinterConnector"));
const SaleLocation =lazy(()=>import("./components/Sales/SaleLocation/SaleLocation"))
const Impo=lazy(()=> import ("./components/Items/BulkImport"))
const SellerPoints = lazy(() => import("./components/Reports/SellerPoints"));
const StockAnalyser = lazy(() => import("./components/StockAnalyser/StockAnalyser"));
const CustomerLedger = lazy(() => import("./components/contact/CustomerLedger"));
const SupplierLedger = lazy(() => import("./components/contact/SupplierLedger"));
const AddItemsOffer = lazy(() => import("./components/ItemsOffer/AddItemsOffer"));
const Card = lazy(() => import("./components/card/AddCard"));
const CardTable = lazy(() => import("./components/card/AssignCardInfo"));
const ItemOfferView = lazy(() => import("./components/ItemsOffer/ItemOfferView"));
const DownloadDatabase = lazy(() => import("./components/admin/DownloadDatabase"));
const PurchaseReturnDetail = lazy(() => import( "./components/purchase/PurchaseReturnDetail")); 
const PrintPurchaseLabels = lazy(() => import( "./components/purchase/PrintPurchaseLabels"));
const CardSetting=lazy(()=>import("./components/card/CardSetting"))
const AllItemsView=lazy(()=>import("./components/ItemsOffer/AllItemsView"))
const PremiumCardReport=lazy(()=>import("./components/Reports/PremiumCardReport.jsx"))
const CartBilling =lazy(()=>import("./components/DeliverySlot/CartBilling.jsx"))
const GetSettings =lazy(()=>import("./components/DeliverySlot/getsettings.jsx"))
const ItemImageEditor = lazy(() => import("./components/Items/ItemImageEditor"));
const ParticularItemReport = lazy(() => import("./components/Reports/ParticularItemReport.jsx"));
const AdminReferralSettings = lazy(() => import("./components/ReferralSetting/AdminReferralSettingsPanel.jsx")); 
const ReferralSettingsView = lazy(() => import("./components/ReferralSetting/ReferralSettingsView.jsx"));
const RiderAssignedOrder=lazy(()=>import("./components/Order/OrderList/RiderAssignedOrder.jsx"))
const VanAssignedOrder=lazy(()=>import("./components/Order/OrderList/VanAssignedOrder.jsx"))
const CardReferralList=lazy(()=>import("./components/card/CardReferralList.jsx"))
const ReferralAdmin =lazy(()=>import("./components/DeliverySlot/ReferralAdmin.jsx"))
const AdminZones=lazy(()=>import("./components/Location/AdminZones.jsx"))
const CustomerLocation=lazy(()=>import("./components/Location/CustomerLocation.jsx"))
const ZoneList=lazy(()=>import("./components/Location/ZoneList.jsx"))
const RiderApproval=lazy(()=>import("./pages/RiderApproval.jsx"))
// const CustomerSalesReport=lazy(()=>import("./components/Reports/CustomerSalesReport.jsx"))

const ReportsList=lazy(()=>import("./components/Reports/ReportsList.jsx"))



const StockReport = lazy(() => import("./components/Reports/newreport/StockReport"));
const SalesReport=lazy(()=>import("./components/Reports/newreport/SalesReport.jsx"))
const SalesReturnReport=lazy(()=>import("./components/Reports/newreport/SalesReturnReport.jsx"))
const PurchaseReport=lazy(()=>import("./components/Reports/newreport/PurchaseReport.jsx"))
const PurchaseReturnReport=lazy(()=>import("./components/Reports/newreport/PurchaseReturnReport.jsx"))
const BillWiseProfitReport=lazy(()=>import("./components/Reports/newreport/BillWiseProfit.jsx"))
const ItemWiseProfitReport=lazy(()=>import("./components/Reports/newreport/ItemWiseProfit.jsx"))
const NewStockTransferReport=lazy(()=>import("./components/Reports/newreport/StockTransferReport.jsx"))
const CustomerSaleReport=lazy(()=>import ("./components/Reports/newreport/CustomerSaleReport.jsx"))
const NewSaleItemsReport = lazy(()=> import ("./components/Reports/newreport/NewSaleItems.jsx"))
const ItemStockHistoryReport = lazy(()=>import("./components/Reports/newreport/ItemStockHistory/ItemStockHistory.jsx"))
const ItemCompare = lazy(() => import("./components/Reports/newreport/stockComparison/ItemCompare.jsx"));
const CustomerReport =lazy(()=>import("./components/Reports/newreport/CustomerReport.jsx"))
const SellerPointReport =lazy(()=>import("./components/Reports/newreport/SellerPointReport.jsx"))
const KeywordUpdate = lazy(()=>import("./components/Items/KeywordUpdate.jsx"))
// const ItemPandLReport=lazy(()=>import("./components/Reports/newreport/ItemPandLReport.jsx"))

const AllTransactionReport =lazy(()=>import("./components/Reports/newreport/AllTransactionReport.jsx"))
const CustomerOrderReport =lazy(()=>import("./components/Reports/newreport/CustomerOrderReport.jsx"))
const CustomerActivityReport =lazy(()=>import("./components/Reports/newreport/CustomerActivityReport.jsx"))
const DeliveryChargesReport =lazy(()=>import("./components/Reports/newreport/DeliveryChargesReport.jsx"))
const DeliveryRiderReport =lazy(()=>import("./components/Reports/newreport/DeliveryRider.jsx"))
const PartyWiseItemReport =lazy(()=>import("./components/Reports/newreport/PartyWiseItemReport.jsx"))
const LowStockItemReport =lazy(()=>import("./components/Reports/newreport/LowStockReport.jsx"))
const DeadStockItemReport =lazy(()=>import("./components/Reports/newreport/DeadStockReport.jsx"))
const ExpiredStockItemReport =lazy(()=>import("./components/Reports/newreport/ExpiredStockReport.jsx"))
const InventoryTurnOverReport =lazy(()=>import("./components/Reports/newreport/InventoryTurnOverReport.jsx"))
const SalesTrendReport =lazy(()=>import("./components/Reports/newreport/SalesTrendReport.jsx"))
const CustomerRetentionReport =lazy(()=>import("./components/Reports/newreport/CustomerRetentionReport.jsx"))
const CategoryWiseReport =lazy(()=>import("./components/Reports/newreport/CategoryWiseReport.jsx"))
const ForecastingReport =lazy(()=>import("./components/Reports/newreport/ForecastingReport.jsx"))
const DiscountImpactReport =lazy(()=>import("./components/Reports/newreport/DiscountImpactReport.jsx"))
const WarehouseUtilizeReport =lazy(()=>import("./components/Reports/newreport/WarehouseUtilize.jsx"))
const SaleVsInventoryReport =lazy(()=>import("./components/Reports/newreport/SaleVsInventory.jsx"))
const SeasonSaleReport =lazy(()=>import("./components/Reports/newreport/SeasonSales.jsx"))
const PaymentReport =lazy(()=>import("./components/Reports/newreport/PaymentMethod.jsx"))
const ClubBillReport = lazy(() => import("./components/Reports/ClubReport"));
const ClubBILLReport = lazy(() => import("./components/Reports/newreport/ClubBillReport.jsx"));
const PurchaseItemReport = lazy(() => import("./components/Reports/newreport/PurchaseItemReport.jsx"));
const HsnStockReport = lazy(() => import("./components/Reports/newreport/HsnStockReport.jsx"))
const HsnGstCompareReport = lazy(() => import("./components/Reports/newreport/HsnGstCompare.jsx"))
// const SalesReport=lazy(()=>import("./components/Reports/NewReports/SalesReport.jsx"))
// const SalesReturnReport=lazy(()=>import("./components/Reports/NewReports/SalesReturnReport.jsx"))
// const PurchaseReport=lazy(()=>import("./components/Reports/NewReports/PurchaseReport.jsx"))
// const PurchaseReturnReport=lazy(()=>import("./components/Reports/NewReports/PurchaseReturnReport.jsx"))
// const BillWiseProfitReport=lazy(()=>import("./components/Reports/NewReports/BillWiseProfit.jsx"))
// const ItemWiseProfitReport=lazy(()=>import("./components/Reports/NewReports/ItemWiseProfit.jsx"))
// const NewStockTransferReport=lazy(()=>import("./components/Reports/NewReports/StockTransferReport.jsx"))
// const ItemStockLedgerReport=lazy(()=>import("./components/Reports/newreport/ItemStockLedgerReport.jsx"))
// const CustomerSaleReport=lazy(()=>import ("./components/Reports/NewReports/CustomerSaleReport.jsx"))
/* ─────────────── APP ─────────────── */
const ItemFreezePage = lazy(() => import("./pages/ItemFreezePage.jsx"));
const UserAccountList = lazy(() => import("./components/Accounts/UserAccountList.jsx"));
const LocalProductsList = lazy(() => import("./components/LocalProducts/LocalProductsList.jsx"));
const UserAccountLedger = lazy(() => import("./components/Accounts/UserAccountLedger.jsx"));
const DealsSectionManager = lazy(() => import("./components/Items/DealSectionManager.jsx"));
const ReferralBannerManager = lazy(() => import("./components/ReferralSetting/ReferralBannerManager.jsx"));
const AppAnalyticsDashboard = lazy(() => import("./components/AppAnalytics/AppAnalyticsDashboard.jsx"));
const CustomerAppEvents = lazy(() => import("./components/AppAnalytics/CustomerAppEvents.jsx"));
const StockAnalysernew = lazy(() => import("./components/Reports/newreport/StockAnalyser.jsx"))
const PurchaseanalysisReport = lazy(() => import("./components/Reports/newreport/Purchaseanalyserreport.jsx"))
const CartOffersList            = lazy(() => import("./components/cartOffers/CartOffersList"));
const NearbySales = lazy(() => import("./components/Sales/NearbySales"));
const LocationWiseClubBillReport = lazy(() => import("./components/Reports/LocationWiseClubBillReport"));
const BasketAffinity = lazy(() => import("./components/Reports/newreport/BasketAffinity.jsx"))
const SectorPerformance = lazy(() => import("./components/Reports/newreport/SectorPerformance.jsx"))
const CustomerRegisterOrderReport = lazy(()=>import("./components/Reports/newreport/CustomerRegisterOrderReport.jsx"))

const CreateCartOffer           = lazy(() => import("./components/cartOffers/CreateCartOffer"));function App() {
  return (
    <Router>
      <Suspense fallback={<div style={{ padding: 24 }}>Loading…</div>}>
        <Routes>
                   <Route  path="/premium-card-report" element={<PremiumCardReport />} />
<Route path="/order/view/rider-assigned" element={<RiderAssignedOrder />} />
        <Route path="/order/view/van-assigned" element={<VanAssignedOrder />} />
        
            <Route path="/card-detail-navigator" element={<CardDetailNavigator />} />
           
            <Route path="/reports-list" element={<ReportsList />} />



            <Route path="/reports/sales-report" element={<SalesReport />} />
        <Route path="/reports/sales-return" element={<SalesReturnReport />} />
        <Route path="/reports/purchase-report" element={<PurchaseReport />} />
        <Route path="/reports/purchase-return" element={<PurchaseReturnReport />} />
        <Route path="/reports/bill-wise-report" element={<BillWiseProfitReport />} />
        <Route path="/reports/item-wise-profit-report" element={<ItemWiseProfitReport />} />
        <Route path="/reports/stock-transfer-report" element={<NewStockTransferReport />} />
        <Route path="/reports/customer-sale-report" element={<CustomerSaleReport />} />
        <Route path="/reports/sale-items-report" element={<NewSaleItemsReport  />} />
        <Route path="/reports/items-stock-history-report" element={<ItemStockHistoryReport  />} />
        <Route path="/reports/stock" element={<StockReport />} />
        <Route path="/reports/item-compare" element={<ItemCompare />} />
        <Route path="/reports/customer" element={<CustomerReport />} />
        <Route path="/reports/seller-point" element={<SellerPointReport />} />
        <Route path="/reports/all-transaction-report" element={<AllTransactionReport />} />
        <Route path="/reports/customer-order-report" element={<CustomerOrderReport />} />
        <Route path="/reports/customer-activity-report" element={<CustomerActivityReport />} />
        <Route path="/reports/delivery-charge-report" element={<DeliveryChargesReport />} />
        <Route path="/reports/delivery-rider-report" element={<DeliveryRiderReport />} />
        <Route path="/reports/partywise-item-report" element={<PartyWiseItemReport />} />
        <Route path="/reports/lowstock-item-report" element={<LowStockItemReport />} />
        <Route path="/reports/deadstock-item-report" element={<DeadStockItemReport />} />
        <Route path="/reports/expiredstock-item-report" element={<ExpiredStockItemReport />} />
        <Route path="/reports/inventoryturnover-report" element={<InventoryTurnOverReport />} />
        <Route path="/reports/salestrend-report" element={<SalesTrendReport />} />
        <Route path="/reports/customer-retention-report" element={<CustomerRetentionReport />} />
        <Route path="/reports/categorywise-report" element={<CategoryWiseReport />} />
        <Route path="/reports/forecasting-report" element={<ForecastingReport />} />
        <Route path="/reports/discount-impact-report" element={<DiscountImpactReport />} />
        <Route path="/reports/warehouse-utilize-report" element={<WarehouseUtilizeReport />} />
        <Route path="/reports/sale-inventory-report" element={<SaleVsInventoryReport />} />
        <Route path="/reports/seasonsale-report" element={<SeasonSaleReport />} />
        <Route path="/reports/payment-report" element={<PaymentReport />} />
        <Route path="/reports/club-bill" element={<ClubBillReport />} />
        <Route path="/reports/purchase-item" element={<PurchaseItemReport />} />

            
            <Route path="/items-keyword-update" element={<KeywordUpdate />} />
            <Route path="/rider-approval" element={<RiderApproval />} />
            <Route  path="/card" element={<Card />} />  
             <Route  path="/card-setting" element={<CardSetting />} />      
          <Route  path="/card-table" element={<CardTable />} />
          <Route  path="/all-items-view" element={<AllItemsView />} />
          <Route path="/item-offer-view" element={<ItemOfferView />} />
         <Route path="/add-items-offer" element={<AddItemsOffer />} />
          <Route path="/bulk-import" element={<Impo />} />
          <Route path="/sale-location"       element={<SaleLocation />} />
          <Route path="/admin-register"       element={<AdminRegister />} />
          <Route path="/"                     element={<AdminLogin />} />
          <Route path="/user-login"           element={<UserLogin />} />
          <Route path="/audit-login"          element={<AuditorLogin />} />
          <Route path="/stock-analyser"       element={<StockAnalyser />} />
          <Route element={<RequireAuth />}>
          <Route path="/dashboard"            element={<AdminDashboard />} />
          <Route path="/auditor-dashboard"    element={<AuditDashboard />} />
          <Route path="/admin/add/user"       element={<AddUser />} />
          <Route path="/admin/user/list"      element={<UserList />} />
          <Route path="/create-user"          element={<CreateUres />} />
          <Route path="/admin/role/list"      element={<RoleList />} />
          <Route path="/admin/create/list"    element={<CreateRolelist />} />
          <Route path="/rider/list"           element={<RiderList />} />
          <Route path="/rider/add"            element={<CreateRider />} />
          <Route path="/rider-commission/create" element={<CreateRiderCommission />} />
          <Route path="/rider-commission/view"   element={<RiderCommissionList />} />
          <Route path="/account/rider/view"      element={<RiderAccountList />} />
          <Route path="/customer/add"            element={<Addcustomer />} />
          <Route path="/customer/view"           element={<Customerlist />} />
          <Route path="/customer/new"            element={<NewCustomer />} />
          <Route path="/customer/new/list"       element={<NewCustomerlist />} />
          <Route path="/supplier/add"            element={<AddSupplier />} />
          <Route path="/supplier/view"           element={<Supplierlist />} />
          <Route path="/customer/import"         element={<ImportCustomer />} />
          <Route path="/supplier/import"         element={<ImportSupplier />} />
          <Route path="/items/add"               element={<AddItem />} />
          <Route path="/items/new"               element={<NewItem />} />
          <Route path="/services/add"            element={<AddService />} />
          <Route path="/add-update-services"     element={<AddUpdateServices />} />
          <Route path="/item-list"               element={<ItemList />} />
          <Route path="/categories-list"         element={<CategoriesList />} />
          <Route path="/categories-list-form"    element={<ImportEntity entity="categories" />} />
          <Route path="/subcategories-list"      element={<SubCategoryList />} />
          <Route path="/subcategories-form"      element={<ImportEntity entity="subcategories" />} />
          <Route path="/sub-subcategories-form"  element={<ImportEntity entity="sub-subcategories" />} />
          <Route path="/sub-subcategory-list"    element={<SubSubCategoryList />} />
          <Route path="/brands-list"             element={<BrandsList />} />
          <Route path="/brand-form"              element={<BrandForm />} />
          <Route path="/variants-list"           element={<VariantsList />} />
          <Route path="/variant-add"             element={<VariantAdd />} />
          <Route path="/print-labels"            element={<PrintLabels />} />
          <Route path="/import-items"            element={<ImportItems />} />
          <Route path="/import-services"         element={<ImportServices />} />
          <Route path="/categories/import"       element={<ImportEntity entity="categories" />} />
          <Route path="/subcategories/import"    element={<ImportEntity entity="subcategories" />} />
          <Route path="/sub-subcategories/import" element={<ImportEntity entity="sub-subcategories" />} />
          <Route path="/store/add"               element={<AddStore />} />
          <Route path="/admin/store/edit"        element={<AddStore />} />
          <Route path="/store/view"              element={<StoreView />} />
          <Route path="/add-subscription"        element={<AddSubscription />} />
          <Route path="/subscription-list"       element={<SubscriptionList />} />
          <Route path="/subscription-list/:storeId" element={<SubscriptionList />} />
          <Route path="/edit-subscription/:id"   element={<AddSubscription />} />
          <Route path="/warehouse-form"          element={<WarehouseForm />} />
          <Route path="/warehouse-list"          element={<WarehouseList />} />
          <Route path="/warehouse-tracker"       element={<WarehouseTracker />} />
          <Route path="/terminal-list"           element={<TerminalList />} />
          <Route path="/create-terminal"         element={<CreateTerminal />} />
          <Route path="/reports"                 element={<Reports />} />
          <Route path="/hsn-stock-report" element={<HsnStockReport />}/>
          <Route path="/hsn-gst-compare-report" element={<HsnGstCompareReport />} />
          {/* <Route path="/reports/profit-loss"     element={<ProfitLossReport />} /> */}
          {/* <Route path="/reports/sales-payment"   element={<SalesPaymentReport />} /> */}
          {/* <Route path="/reports/customer-orders" element={<CustomerOrders />} /> */}
          {/* <Route path="/reports/stock-transfer"  element={<StockTransferReport />} /> */}
          <Route path="/reports/seller-points" element={<SellerPoints />} /> 
           {/* <Route path="/reports/particular-item" element={<ParticularItemReport />} /> */}
          {/* <Route path="/reports/sale-item"       element={<SaleItemsReport />} /> */}
          {/* <Route path="/reports/stock"           element={<StockReport />} /> */}
          {/* <Route path="/reports/item-compare"    element={<ItemCompare />} /> */}
          {/* <Route path="/reports/item-transfer"   element={<ItemTransfer />} /> */}
          <Route path="/add-advance"             element={<AddAdvance />} />
          <Route path="/advance-list"            element={<AdvanceList />} />
          <Route path="/customer/coupon/view"    element={<CustomerCoupenList />} />
          <Route path="/customer/coupon/add"     element={<CreateCustomerCoupons />} />
          <Route path="/master/coupon/add"       element={<CreateMasterCoupon />} />
          <Route path="/master/coupon/view"      element={<CouponsMaster />} />
          <Route path="/create"                  element={<CouponForm />} />
          <Route path="/create-coupon"           element={<DiscountCouponForm />} />
          <Route path="/coupon-master"           element={<DiscountCouponList />} />
          <Route path="/newquotation"            element={<NewQuotation />} />
          <Route path="/quotation-list"          element={<QuotationList />} />
          <Route path="/quotation/edit/:id"      element={<QuotationForm />} />
          <Route path="/new-purchase"            element={<NewPurchase />} />
          <Route path="/purchase-list"           element={<PurchaseList />} />
          <Route path="/purchasereturn-list"     element={<PurchaseReturnsList />} />
          <Route path="/purchase-return"         element={<PurchaseReturn />} />
          <Route path="/pos"                     element={<POS />} />
          <Route path="/add-sale"                element={<AddSale />} />
          <Route path="/sales-return/add"        element={<AddSalesRetutrn />} />
          <Route path="/sales-return"            element={<SalesReturn />} />
          <Route path="/sales-return/edit/:id"   element={<AddSalesReturn />} />
          <Route path="/sale-list"               element={<SaleList />} />
          <Route path="/view-sale"               element={<ViewSale />} />
          <Route path="/view-sale-report"               element={<ViewSaleReport />} />
          <Route path="/sales-payment"           element={<SalesPayment />} />
          <Route path="/sales-payment-list"      element={<SalesPaymentList />} />
          <Route path="/receive-payment"         element={<ReceivePayment />} />
          <Route path="/pos-invoice/:id"         element={<POSInvoice />} />
          <Route path="/view-payment"            element={<ViewPayment />} />
          <Route path="/add-account"             element={<AddAccount />} />
          <Route path="/account-list"            element={<AccountList />} />
          <Route path="/accounts/:accountId/ledger" element={<AccountLedger />} />
          <Route path="/money-transfer-list"     element={<MoneyTransferList />} />
          <Route path="/add-money-transfer"      element={<AddMoneyTransfer />} />
          <Route path="/add-deposit"             element={<AddDeposit />} />
          <Route path="/deposit-list"            element={<DepositList />} />
          <Route path="/cash-transactions"       element={<CashTransactions />} />
          <Route path="/ledger/van-cash/new"     element={<AddVanCash />} />
          <Route path="/stock-adjustment"        element={<AddStockAdjustment />} />
          <Route path="/adjustment-list"         element={<AdjustmentList />} />
          <Route path="/stock-transfer"          element={<AddStockTransfer />} />
          <Route path="/transfer-list"           element={<TransferList />} />
          <Route path="/expense-list"            element={<ExpenseList />} />
          <Route path="/add-expense"             element={<AddExpense />} />
          <Route path="/add-expense-category"    element={<AddExpenseCategory />} />
          <Route path="/expense-category-list"   element={<ExpenseCategoryList />} />
          <Route path="/send-message"            element={<SendMessage />} />
          <Route path="/message-templates-list"  element={<MessageTemplatesList />} />
          <Route path="/units-list"              element={<UnitsList />} />
          <Route path="/add-unit"                element={<AddUnit />} />
          <Route path="/edit-unit/:unitId"       element={<AddUnit />} />
          <Route path="/payment-types-list"      element={<PaymentTypesList />} />
          <Route path="/add-payment-type"        element={<AddPaymentType />} />
          <Route path="/edit-payment-type/:paymentTypeId" element={<AddPaymentType />} />
          <Route path="/change-password"         element={<ChangePassword />} />
          <Route path="/store"                   element={<Store />} />
          <Route path="/tax-list"                element={<TaxList />} />
          <Route path="/add-tax"                 element={<AddTax />} />
          <Route path="/edit-tax/:taxId"         element={<AddTax />} />
          <Route path="/add-tax-group"           element={<AddTaxGroup />} />
          <Route path="/edit-tax-group/:taxGroupId" element={<AddTaxGroup />} />
          <Route path="/sms-api"                 element={<SmsApi />} />
          <Route path="/pos-settings"            element={<PosSettingsForm />} />
          <Route path="/system-tab"              element={<SystemTab />} />
          <Route path="/add-country"             element={<AddCountry />} />
          <Route path="/edit-country/:countryId" element={<AddCountry />} />
          <Route path="/country-list"            element={<CountryList />} />
          <Route path="/add-state"               element={<AddState />} />
          <Route path="/edit-state/:stateId"     element={<AddState />} />
          <Route path="/state-list"              element={<StateList />} />
          <Route path="/banners/add"             element={<AddBanner />} />
          <Route path="/banners/view"            element={<BannersList />} />
          <Route path="/marketingitem/add"       element={<AddMarketingItems />} />
          <Route path="/marketingitem/view"      element={<MarketingItemsList />} />
          <Route path="/product/add"             element={<AddProduct />} />
          <Route path="/product/view"            element={<ProductListView />} />
          <Route path="/admin/deletion-requests" element={<DeletionRequests />} />
          <Route path="/admin/download-database"       element={<DownloadDatabase />} />
          <Route path="/profile/edit"            element={<ProfileEdit />} />
          <Route path="/order/view"              element={<OrderList />} />
          <Route path="/delivery-slot/create"    element={<DeliverySlotCreate />} />
          <Route path="/delivery-slot/view"      element={<DeliverySlotList />} />
          <Route path="/audit"                   element={<Audit />} />
          <Route path="/audit/open"              element={<OpenAuditList />} />
          <Route path="/audit/all"               element={<AllAudits />} />
          <Route path="/bucket-create"           element={<BucketCreate />} />
          <Route path="/bucket-list"             element={<UserBucketList />} />
          <Route path="/image"                   element={<ImageMerger />} />
          <Route path="/item/image-management"   element={<ItemImageManagement />} />
          <Route path="/category/image-management" element={<CategoryImageManagement />} />
          <Route path="/subcategory/image-management" element={<SubCategoryImageManagement />} />
          <Route path="/subsubcategory/image-management" element={<SubSubCategoryImageManagement />} />
          <Route path="/address-manager"         element={<AddressManager />} />
          <Route path="/address-list"            element={<AddressList />} />
          <Route path="/chat-panel"              element={<ChatPanel />} />
          <Route path="/raw-lots"                element={<RawLotList />} />
          <Route path="/bulk-transfer"           element={<BulkStockTransfer />} />
          <Route path="/bulk-purchase-upload"    element={<BulkPurchaseUpload />} />
          <Route path="/transfer-details/:id"    element={<TransferDetails />} />
          <Route path="/purchase-detail/:id"     element={<PurchaseDetail />} />
          <Route path="/van/bookings"            element={<AdminBookingPanel />} />
          <Route path="/rider/claim"             element={<RiderClaimPanel />} />
          <Route path="/my-jobs"                 element={<MyJobsPanel />} />
          <Route path="/bluetooth-printer"       element={<BluetoothPrinterConnector />} />
          <Route path="/customer/ledger/:customerId" element={<CustomerLedger />} />
                  <Route path="/supplier/ledger/:supplierId" element={<SupplierLedger />} />
                  <Route path="/purchase-return-detail/:id" element={<PurchaseReturnDetail />} />
                  <Route path="/print-purchase-labels/:id" element={<PrintPurchaseLabels />} />
          <Route path="/cart-billing"            element={<CartBilling/>} />
          <Route path="/get-settings"            element={<GetSettings/>} />
          <Route path="/item-image-editor/:itemId" element={<ItemImageEditor />} />
          <Route path="/referral-settings"       element={<AdminReferralSettings />} />
          <Route path="/referral-view"           element={<ReferralSettingsView />} />
          <Route path="/card-referrals" element={<CardReferralList />} />
          <Route path="/referral-admin" element={<ReferralAdmin />} />
          <Route path="/admin-zones" element={<AdminZones />} />
          <Route path="/customer-location" element={<CustomerLocation />} />
          <Route path="/zone-list" element={<ZoneList />} />
          <Route path="/club-bill-report" element={<ClubBILLReport />} />
          <Route path="/freeze-item" element={<ItemFreezePage />} />
          <Route path="/user-account/list"   element={<UserAccountList />} />
          <Route path="/user-account/ledger" element={<UserAccountLedger />} />
                    <Route path="/local-products"      element={<LocalProductsList />} />
<Route path="/deal-sections" element={<DealsSectionManager />} />
<Route path="/referral-banner-manager" element={<ReferralBannerManager />} />
<Route path="/app-analytics" element={<AppAnalyticsDashboard />} />
<Route path="/app-analytics/customer/:customerId" element={<CustomerAppEvents />} />
<Route
  path="/reports/stock-analyser"
  element={<StockAnalysernew/>}
/>
<Route
  path="/reports/purchase-analyser"
  element={<PurchaseanalysisReport/>}
/>
  <Route path="/cart-offers/view"        element={<CartOffersList />} />
          <Route path="/cart-offers/add"         element={<CreateCartOffer />} />
          <Route path="/nearby-sales"       element={<NearbySales />} />
          <Route path="/reports/location-club-bill" element={<LocationWiseClubBillReport />} />
          <Route
  path="/reports/basket-affinity"
  element={<BasketAffinity/>}
/>
<Route
  path="/reports/sector-performance"
  element={<SectorPerformance/>}
/>
<Route path="/reports/customer-register-order-report" element={<CustomerRegisterOrderReport />} />
           {/* <Route
  path="/reports/stock-ledger"
  element={<ItemStockLedgerReport />}
/> */}
{/* <Route
  path="/reports/item-pandl-report"
  element={<ItemPandLReport />}
/> */}


          

        </Route>
</Routes>
      </Suspense>
    </Router>
  );
}

export default App;